var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(c){return _c('v-checkbox',_vm._g(_vm._b({key:c.ID,attrs:{"label":c.DisplayText,"value":c.ID,"multiple":""}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }